import { useTheme } from "@mui/material";

export const useMainDarkBackground = () => {
  const theme = useTheme();

  const mainDarkBackgroundColor = () => theme?.palette?.secondary?.mainDarkBackground || "white";

  return { mainDarkBackgroundColor };
};
